import Button from "src/components/shared/Button";
import styled from "styled-components";

// export default styled(Button)`
//   box-sizing: border-box;
//   border: 3px solid transparent;
//   position: relative;

//   &::after {
//     position: absolute;
//     content: "";
//     left: -1px;
//     width: calc(100% + 3px);
//     height: calc(100% + 3px);
//     border-radius: 8px;
//     border: 1px solid black;
//   }

//   &:hover:not(:disabled) {
//     border: 3px solid black;
//   }
// `;

export default styled(Button)`
  position: relative;

  &::after {
    position: absolute;
    content: "";
    width: 100%;
    height: 100%;
    border-radius: 8px;
    border: 1px solid black;
    transition: all 0.1s ease-in-out;
  }

  &:hover::after {
    border: 3px solid black;
  }
`;

